import {OfferTextModuleModel} from './offer-text-module.model';

export class MyOfferTextModuleContainerModel {
    offerTextModule: OfferTextModuleModel;
    isChecked: boolean;
    id: number;

    public static getNewModel(offerTextModule = new OfferTextModuleModel(), id?: number): MyOfferTextModuleContainerModel {
        return {
            offerTextModule: offerTextModule,
            isChecked: false,
            id: id
        } as MyOfferTextModuleContainerModel;
    }
}
